import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=525d0f26&scoped=true&"
import script from "./DeleteUser.vue?vue&type=script&lang=js&"
export * from "./DeleteUser.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=525d0f26&prod&lang=css&"
import style1 from "./DeleteUser.vue?vue&type=style&index=1&id=525d0f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d0f26",
  null
  
)

export default component.exports